var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('div',{staticClass:"image-container"},[_c('custom-image',{staticClass:"image",attrs:{"media":_vm.fields.mainImage,"size":"cloudinary_header_image_large"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }